import { withToastify } from "./withToastify";
import { withServiceWorker } from "./withServiceWorker";
import { compose } from "shared/utils/compose";
import { withLocalization } from "./withLocalization";
import { withSWR } from "./withSWR";
import { withTheme } from "./withTheme";

export const withProviders = compose(
  withToastify,
  withServiceWorker,
  withLocalization,
  withTheme,
  withSWR
);
